import React, { useContext } from "react";
import "./SubscribeNow.scss";
import Button from "../Button/Button";
import { DataContext } from "../../DataContext";

const SubscribeNow = () => {
  const { data, loading } = useContext(DataContext);

  //const subAmount = data?.subscriptionAmount || 500;
  // Added this for payAmount 
  // const payAmount = data?.payAmount || 99;

  //const subDurationValue = data?.subscriptionDuration || 30;
  const subscriptionName = data?.subscriptionName || 'MONTHLY UNLIMITED';
  const planOriginalValue = data?.planOriginalValue;
  const updatedSubscriptionAmount = data?.updatedSubscriptionAmount || 500;

  /*const durationMapping = {
    1: "DAY",
    3: "DAYS",
    7: "WEEK",
    15: "HALF MONTH",
    30: "MONTH",
    60: "2 MONTHS",
    90: "QUARTER",
    180: "HALF YEAR",
    365: "YEAR",
  };*/

  //const subDuration = `${durationMapping[subDurationValue]}`;


  // Show loading state
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <section className="subscribe-now">
      <div className="container">
        <div className="subscribe-now__card">
          <div className="subscribe-now__card-header">
            <h2>
              SUBSCRIBE NOW
              <span>
                & get <strong>FREE</strong> home delivery
              </span>
            </h2>
          </div>

          <div className="subscribe-now__card-unlimited">
            <p>
              <strong>{subscriptionName} </strong>
              {/* <span>({subDuration})</span> */}
            </p>
          </div>

          <div className="subscribe-now__card-price">
            <h3><b className="rupee-symbol">₹</b>{updatedSubscriptionAmount}</h3>
            {(planOriginalValue !== null && planOriginalValue !== undefined && planOriginalValue !== 0) && (
              <small><span className="rupee-symbol">₹</span>{planOriginalValue}</small>
            )}
           
          </div>
          <Button />
        </div>
      </div>
    </section>
  );
};

export default SubscribeNow;
